module.exports = __webpack_public_path__ + "media/assets/img/company/logo rtbfredi-1f5e50cdb7e1167cece019ca6d85ab11.png";